import styled from "styled-components";

export const CenteredContainer = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: 2rem auto;
  padding: 0 1rem;
  box-sizing: border-box;
`;